import React, { memo } from "react";
import { useRoutes } from "react-router-dom";
import { ConfigProvider } from "antd";

import { theme } from "./base-ui/theme";
import routes from "@/router";

import zhCN from "antd/locale/zh_CN";

// 这里原本是 <Suspense fallback={<Loading />}>{useRoutes(routes)}</Suspense>。
//
// 已移除：React 18 的 hydration 要求每个 Suspense 边界在 HTML 里有 `<!--$-->` 标记，
// 而 react-snap 的产物是浏览器 DOM 快照、没有这个标记，边界必然 hydrate 失败
// （#418），进而整个 root 改走客户端渲染（#423）—— 预渲染出的完整 DOM 被整棵丢弃。
// 路由组件的按需加载改由 src/router/preloadable-route.js 用 state 完成，不再需要
// Suspense 边界。原委与实测报错见该文件头。
//
// 因此：**不要在这棵树里重新引入 React.lazy 或任何会 suspend 的渲染**，
// 否则既没有 fallback 边界会直接抛错，加了边界又会把 hydration 打回原形。
const App = memo(() => {
	return (
		<ConfigProvider theme={theme} locale={zhCN}>
			{useRoutes(routes)}
		</ConfigProvider>
	);
});

export default App;
